import _ from 'lodash'
import dayjs from 'dayjs'

const _parseHierarchicalObjects = function (obj, path = []) {
  if (!obj) return []
  const keys = Object.keys(obj)
  return keys
    .map(key => {
      if (!obj[key].children) {
        const base = {}
        Object.keys(obj[key]).map(k => {
          base[k] = obj[key][k]
        })
        base.path = [...path, {
          id: obj[key].id,
          name: obj[key].name
        }]
        return [base]
      }
      return _parseHierarchicalObjects(obj[key].children, [...path, {
        id: obj[key].id,
        name: obj[key].name
      }])
    })
    .reduce((arr, it) => {
      return [...arr, ...it]
    }, [])
}

// id, childrenを持つ階層構造オブジェクトに対し、基底オブジェクトへのパスを解析します。
// ex.)
// [{                                                  [{
//   id: 1,                                                "id": 1,
//   name: 'ITエンジニア関連職種',                            "name": "要件定義"
//   children: [{                                          "path": [
//     id: 1,                                 ->              { "id": 1, "name": "ITエンジニア関連職種" },
//     name: '経験業務',                                       { "id": 1, "name": "経験業務" },
//     children: [{                                           { "id": 1, "name": "システム開発（ オープン・ Web系）" },
//       id: 1,                                               { "id": 1, "name": "要件定義" }
//       name: 'システム開発（ オープン・ Web系）',             ]
//       children: [{                                   }]
//           id: 1,
//           name: '要件定義'
//         }]
//     }]
//   }]
// }]
const parseHierarchicalObjects = function (obj) {
  return _parseHierarchicalObjects(obj)
}

// skillオブジェクトにpathを追加する
const skills = function (skills, parsedSkillsMaster) {
  return _(skills).map(o => {
    return _.assign(o, _.pick(_.find(parsedSkillsMaster, { id: o.id }), 'path'))
  }).value()
}

// 中項目でグルーピングしたスキル一覧を返す
// skillsMaster : storeから取得
// parsedSkills : skills(skills, parsedSkillsMaster)で整形したスキル一覧
// groupingKey : id / name
const layeredSkillsByLv2CategoryMap = function (skillsMaster, parsedSkills, groupingKey) {
  return skillsMaster
    .map(skillMaster => {
      return _(parsedSkills) // skillsで成型された、登録スキル＋pathの配列
        .filter(_.matchesProperty('path[0].id', skillMaster.id)) // 大項目(第1階層)で絞る
        .groupBy(_.property(`path[1].${groupingKey}`)) // 中項目(第2階層)でグルーピングする
        .toPairs().value() // 成型：[['指定されたgroupingKey',[{(スキル名や経験年数のobj)},...]],...]
    })
    .reduce((acc, value, index) => {
      return { ...acc, [skillsMaster[index].id]: value }
    }, {}) // 成形：{"大項目id":[['指定されたgroupingKey',[{(スキル名や経験年数のobj)},{...}]],[...]],...}
}

const age = (birthdateString) => {
  return birthdateString ? dayjs().diff(dayjs(birthdateString), 'years') : ''
}

export {
  parseHierarchicalObjects,
  skills,
  layeredSkillsByLv2CategoryMap,
  age
}
